import React from 'react'
import { createStyles, makeStyles } from '@mui/styles'
import LoadingButton from '@mui/lab/LoadingButton'
import { useMailChimp } from 'react-use-mailchimp-signup'
import TextField from '@mui/material/TextField'
import toast from 'react-hot-toast'
import validate from 'validate.js'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
    },
  })
)

const schema = {
  fullName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 120,
    },
  },
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 300,
    },
  },
}

function NewLetterForm() {
  const classes = useStyles()
  const { error, loading, status, subscribe, message } = useMailChimp({
    action: `https://freedisity.us13.list-manage.com/subscribe/post?u=${process.env.REACT_APP_MAILCHIMP_U}&id=${process.env.REACT_APP_MAILCHIMP_ID}`,
  })
  const [formState, setFormState] = React.useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  })

  React.useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((prevData) => ({
      ...prevData,
      isValid: errors ? false : true,
      errors: errors || {},
    }))
  }, [formState.values])

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false

  const handleChange = (event) => {
    event.persist()

    setFormState((prevData) => ({
      ...prevData,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (formState.isValid) {
      const payload = {
        EMAIL: formState.values?.email,
        MERGE1: formState.values?.fullName,
        MERGE7: 'NEWSLETTER',
      }

      toast.promise(subscribe(payload), {
        loading: 'Sending...',
        success: (data) => {
          // CLEAR FORM
          setFormState((prevData) => ({
            ...prevData,
            isValid: false,
            values: {},
            touched: {},
            errors: {},
          }))
          return 'Thank you for Subscribing.'
        },
        error: (err) => {
          console.log(err)
          return 'Something went wrong while submitting, try again'
        },
      })
    }

    setFormState((prevData) => ({
      ...prevData,
      touched: {
        ...formState.touched,
        ...formState.errors,
      },
    }))
  }

  return (
    <form
      name='newsletter-form'
      method='post'
      onSubmit={handleSubmit}
      className={classes.root}
    >
      <TextField
        placeholder='Fullname'
        label='Fullname *'
        variant='outlined'
        name='fullName'
        fullWidth
        helperText={hasError('fullName') ? formState.errors.fullName[0] : null}
        error={hasError('fullName')}
        onChange={handleChange}
        type='text'
        value={formState.values.fullName || ''}
        lightInput={true}
      />
      <TextField
        placeholder='E-mail'
        label='E-mail *'
        variant='outlined'
        name='email'
        fullWidth
        helperText={hasError('email') ? formState.errors.email[0] : null}
        error={hasError('email')}
        onChange={handleChange}
        type='email'
        value={formState.values.email || ''}
        lightInput={true}
      />
      <LoadingButton
        fullWidth
        size="large"
        loading={loading}
        variant='contained'
        type='submit'
        color='primary'
      >
        Join Now
      </LoadingButton>
    </form>
  )
}

export default NewLetterForm
